import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  textField: {
    padding: '0px !important'
  }
}));
